import { memo } from 'react';

import AddIconSVG from '@/assets/add-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IAddIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={AddIconSVG} {...props} />;

export const AddIcon = memo(IAddIcon) as typeof IAddIcon;
